var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStranger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.06 35.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 6.924,
    cy: 6.924,
    r: 6.924,
    transform: "translate(10.945 13.848) rotate(-89.496)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M45.746,10.895A3.017,3.017,0,0,0,41.984,12.8L40.4,17.764a8.373,8.373,0,0,1-5.125,5.288,9.888,9.888,0,0,1-3.544.6h-6.76A8.281,8.281,0,0,0,18,27.523l-6.815,10.9a2.978,2.978,0,0,0,.927,4.089,2.78,2.78,0,0,0,1.581.436,3.055,3.055,0,0,0,2.562-1.417l5.234-8.341v8.45A1.838,1.838,0,0,0,23.339,43.5H33.97a1.838,1.838,0,0,0,1.854-1.854V29.1a14.615,14.615,0,0,0,1.472-.382,14.251,14.251,0,0,0,8.723-9.05L47.6,14.711A2.9,2.9,0,0,0,45.746,10.895Z",
    transform: "translate(-10.73 -7.516)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStranger);
export default __webpack_public_path__ + "static/media/stranger.fba5e168.svg";
export { ForwardRef as ReactComponent };